import { isArrayInArray } from "lib/utils";
import { useSavedSuppliers } from "./useSavedSuppliers";

/**
 * Whether every one of these suppliers is already a competitor or a partner — the two lists the
 * save drawer offers. A button can stand for several suppliers, so it only reads as saved once
 * they all are, and an empty selection never counts as saved.
 */
export function useAllSuppliersSaved(supplierGuids: string[]) {
  const { data: savedSuppliers, isLoading } = useSavedSuppliers();

  const savedGuids = [
    ...(savedSuppliers?.competitorGuids ?? []),
    ...(savedSuppliers?.partnerGuids ?? []),
  ];

  return {
    allSaved: supplierGuids.length > 0 && isArrayInArray(supplierGuids, savedGuids),
    isLoading,
  };
}
